__turbopack_context__.v({
  "outletMoreInfoButton": "geSOkq_outletMoreInfoButton",
});
